/**
 *
 */
(function(window) {
    'use strict';

    const VvUserSrvc = function(CONSTANTS) {
        this.user = {};
        this.abilitazioni = null;
        this.abilitazioniPronte = null;
        this.parametri = null;
        this.parametriInstallazione = null;

        this.modificaAbilitata = () => {
            return this.abilitato(CONSTANTS.ABILITAZIONI.MODIFICA);
        };

        this.consolidaAbilitata = () => {
            return this.abilitato(CONSTANTS.ABILITAZIONI.CONSOLIDA);
        };

        this.accettazioneAbilitata = () => {
            return this.abilitato(CONSTANTS.ABILITAZIONI.ACCETTA);
        };

        this.invioCredenzialiAbilitata = () => {
            return this.abilitato(CONSTANTS.ABILITAZIONI.CREDENZIALI);
        };

        this.switchUtenzaAbilitata = () => {
            return this.abilitato(CONSTANTS.ABILITAZIONI.SWITCH);
        };

        this.estinguiUtenzaAbilitata = () => {
            return this.abilitato(CONSTANTS.ABILITAZIONI.ESTINGUI);
        };

        this.ribaltamentoContiAbilitata = () => {
            return this.abilitato(CONSTANTS.ABILITAZIONI.RIBALTA);
        };

        this.auditAbilitata = () => {
            return this.abilitato(CONSTANTS.ABILITAZIONI.AUDIT);
        };

        this.vipAbilitato = () => {
            return this.abilitato(CONSTANTS.ABILITAZIONI.VIP);
        };
        
        this.incaricatoAbilitata = () => {
        	return this.abilitato(CONSTANTS.ABILITAZIONI.INCARICATO);
        }
        
        this.controlloAccettazioneAbilitata = () => {
        	return this.parametroAbilitato(CONSTANTS.PARAMETRI.CONTROLLO_ACCETTAZIONE);
        }

        this.abilitato = (permission) => {
            if (!this.abilitazioni) {
                return false;
            }

            const applicazione = this.abilitazioni[0].idApplicazione.codice.toLowerCase();
            const listaApplicazioniBrio3 = [ 'brio', 'filiale'];
            const listaApplicazioniEasyDesk = [ 'edrete', 'edfiliale'];

            if (listaApplicazioniBrio3.includes(applicazione)) {
                return this.abilitazioni.some((f) => f.codice.toLowerCase() === permission.nomeFunzionalitaLegacy.toLowerCase());
            }
            if (listaApplicazioniEasyDesk.includes(applicazione)) {
                return this.hasPermissionPropertyValue(permission.nomeFunzionalita, permission.nomeParametroFunzionalita, 'true');
            }

            return false;
        };

        this.hasPermissionPropertyValue = (nomeFunzionalita, nomeParametro, valoreCheck) => {
            if (!this.parametri) {
                return false;
            }

            const parametro = this.parametri.find((item) => 
                item.idDefinizioneParametro.idFunzionalita.codice.toLowerCase() == nomeFunzionalita.toLowerCase()
                &&
                item.idDefinizioneParametro.codice.toLowerCase() == nomeParametro.toLowerCase()
            );
            if (!parametro) {
                return false;
            }
            
            return parametro.valore.toLowerCase() == valoreCheck.toLowerCase();
        };
        
        this.parametroAbilitato = (funzione) => {
            if (!this.parametriInstallazione) {
                return false;
            }
            return this.parametriInstallazione.some((f) => (f.chiave === funzione) && (f.valore === 'true'));
        };
    };

    VvUserSrvc.$inject = ['Mitom_CONSTANTS'];

    angular.module('cbl.mitomanager.wa').service('MitomUserSrvc', VvUserSrvc);
})(window);